<template>
  <Frontendlayout>
    <!-- <section class="hero_in hotels hero_single version_2">
      <FilterType1new :loadNearbyOffers="loadNearbyOffers" :search="search" />
    </section> -->
    <!-- /hero_single -->
    <section class="hero_in general">
			<div class="wrapper">
				<div class="container">
					<h1 class="fadeInUp"><span></span>Offers List</h1>
				</div>
			</div>
		</section>
    <div class="filters_listing sticky_horizontal">
      <div class="container">
        <ul class="clearfix">
          <li>
            <div class="switch-field">
              <input
                type="radio"
                id="all"
                name="listing_filter"
                value="all"
                checked
                data-filter="*"
                class="selected"
              />
              <label for="all">All</label>
              <input
                type="radio"
                id="popular"
                name="listing_filter"
                value="popular"
                data-filter=".popular"
              />
              <label for="popular">Popular</label>
              <input
                type="radio"
                id="latest"
                name="listing_filter"
                value="latest"
                data-filter=".latest"
              />
              <label for="latest">Latest</label>
            </div>
          </li>
          <li>
            <div class="layout_view">
              <a
                @click.prevent="changeview('gridview')"
                :class="gridview == true ? 'active' : ''"
                ><i class="icon-th"></i
              ></a>
              <a
                href="#0"
                :class="listview == true ? 'active' : ''"
                @click.prevent="changeview('listview')"
                ><i class="icon-th-list"></i
              ></a>
            </div>
          </li>
          <li>
            <a href="#" @click="resetFilter()"
              ><span class="badge badge-info">Clear Filter</span></a
            >
          </li>
          <!-- <li>
            <a
              class="btn_map"
              data-toggle="collapse"
              href="#collapseMap"
              aria-expanded="false"
              aria-controls="collapseMap"
              data-text-swap="Hide map"
              data-text-original="View on map"
              >View on map</a
            >
          </li> -->
        </ul>
      </div>
      <!-- /container -->
    </div>
    <!-- /filters -->

    <div class="collapse" id="collapseMap">
      <div id="map" class="map"></div>
    </div>
    <!-- End Map -->

    <div class="container margin_60_35">
      <div class="row">
        <aside class="col-lg-3" id="sidebar">
         <LeftFilter1 />
        </aside>

        <!-- /aside -->

        <div class="col-lg-9" id="list_sidebar">
          <div class="" style="height: 20px" v-show="loader">
            <div class="row">
              <div class="col-lg-12">
                <center>
                  <h3>{{ loadingText }}</h3>
                </center>
              </div>
              <div class="col-lg-12">
                <div data-loader="circle-side"></div>
              </div>
            </div>
          </div>
          <div class="isotope-wrapper">
            <Listrequirement :offerList="offerList" v-show="listview" />
            <ListGridOffer :offerList="offerList" v-show="gridview" />
          </div>
          <!-- /isotope-wrapper -->

          <!-- <p class="text-center add_top_30">
            <a href="#0" class="btn_1 rounded">Load more</a>
          </p> -->
        </div>
        <!-- /col -->
      </div>
      <!-- /row -->
    </div>
    <!-- /container -->

    <!-- /bg_color_1 -->
  </Frontendlayout>
</template>

<script>
  /* eslint-disable */
import API from "@/services/index";
import Frontendlayout from "@/layouts/Frontendlayout.vue";
import { EventBus } from "@/EventBus";
// import FilterType1new from "@/cmps/FilterType1new.vue";
import LeftFilterrequirement from "@/cmps/LeftFilterrequirement.vue";
import Listrequirement from "@/cmps/Listrequirement.vue";
import ListGridOffer from "@/cmps/Listgridoffer.vue";
import LeftFilter1 from "@/cmps/LeftFilter1.vue";

export default {
  props: {
    search: {
      type: Object,
      default: () => {
        return {
          pincode: "",
          location: "",
          event: '',
        };
      },
    },
  },
  created() {
    EventBus.$on("emittedData", (data) => {
      // console.log("filter pincode:" + data.search.pincode);
      this.catOptions = data.catList;
      this.subCatOptions = data.subCatList;
    });
  },
  data() {
    return {
      offerList: [],
      listview: true,
      gridview: false,
      loader: false,
      loadingText:'',
	  searchcat:{
        categories:[],
        subcategories:[],
      },
      catOptions: [],
      subCatOptions: [],
    };
  },
  beforeMount() {

	 this.getList()
  this.getParentCategories();
  },

  components: {
    Frontendlayout,
    LeftFilterrequirement,
    Listrequirement,
    ListGridOffer,
    LeftFilter1,
  },
  methods: {
    getParentCategories() {
     
       API .get("categories/parent_services_select2list")
        //.get("categories/parent_services")
        .then((res) => {
          this.catOptions = res.data.data;
        })
        .catch((err) => {
          console.log(err.response);
        });
    },
    setSubCategory(categoryId, mode) {
      //alert(categoryId);
      let selSubCat = this.searchcat.subcategories;
      API
        .get(
          "categories/parent_services_select2list/" + window.btoa(categoryId)
        )
        //.get("categories/parent_services")
        .then((res) => {
          if (mode == "push") {
            res.data.data.forEach((val) => {
              this.subCatOptions.push(val);
              
              //this.subCatOptions.concat(res.data.data);
            });

            //console.log("sub cat options=" + this.subCatOptions);
          } else {
            //this.search.subcategories.push(res.data.data);
            res.data.data.forEach((val) => {
              this.subCatOptions.splice(this.subCatOptions.indexOf(val.id), 1);
            });
          }
            this.searchcat.subcategories=[];
          // this.searchcat.subcategories = selSubCat;
         // this.emitFilterRequest();
          //this.loadNearbyOffers(this.search);
        })
        .catch((err) => {
          console.log(err.response);
        });
    },
    catSelectEvent(e) {
      var sel = e.selected;
      if (sel) {
        this.setSubCategory(e.id, "push");
        this.searchcat.categories.push(e.id);
      } else {
        this.setSubCategory(e.id, "remove");
        this.searchcat.categories.splice(this.searchcat.categories.indexOf(e.id), 1);
      
    
          
      }
    },
    subcatselectEvent(e) {
      var sel = e.selected;
      //alert(sel + " " + e.id + " " + e.text + " " + e.selected);
      if (sel) {
        this.searchcat.subcategories.push(e.id);
           this.loadNearbyOffers()
      } else {
       
      }
   
      //this.loadNearbyOffers(this.search);
    },
    changeview(view) {
      if (view == "listview") {
        this.listview = true;
        this.gridview = false;
      } else {
        this.listview = false;
        this.gridview = true;
      }
    },
    resetFilter() {
      this.search = {
        pincode: "",
        location: "",
        categories: [],
        subcategories: [],
        mindiscount: "",
        maxdiscount: "",
        discount_type: "",
      };
    },
	 getList(){
		const token = "Bearer " + localStorage.getItem("token");
		 API.get("Postrequirement/getList", {
        headers: { Authorization: token },
      })
        .then((res) => {
           this.offerList=res.data.data
        })
        .catch((err) => {
          console.log(err.response);
        });
	  },
    loadNearbyOffers(e) {
      console.log(e);
        this.offerList=[];
      this.loader = true;
      const form = new FormData();
      //alert($(".childcat").is(":checked").val());
      //if (filter != "all")
      form.append("search", JSON.stringify(this.search));
      form.append("categories", JSON.stringify(this.searchcat.categories));
      form.append("subcategories", JSON.stringify(this.searchcat.subcategories));

     	const token = "Bearer " + localStorage.getItem("token");
		 API.post("Postrequirement/search",form ,{
        headers: { Authorization: token },
      }).then((res) => {
        this.loader = false;
        this.loading = false;
        if (res.data.status == 200) {
          this.offerList = res.data.data;
          //this.$swal("Success", res.data.messages);
        } else {
           this.offerList =[];
          // this.$swal("Error", res.data.messages);
        }
      });
    },
  },
};
</script>


<style  scoped>
/*@import "../../public/frontend/css/custom.css";*/
a {
  color: #fc5b62 !important;
}
</style>